"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("util");
const classes_1 = require("../classes");
class CreateTimerAction {
    constructor(fireAt, isCanceled = false) {
        this.fireAt = fireAt;
        this.isCanceled = isCanceled;
        this.actionType = classes_1.ActionType.CreateTimer;
        if (!util_1.isDate(fireAt)) {
            throw new TypeError(`fireAt: Expected valid Date object but got ${fireAt}`);
        }
    }
}
exports.CreateTimerAction = CreateTimerAction;
//# sourceMappingURL=createtimeraction.js.map